class CustomDropdown extends HTMLElement {
	constructor() {
		super()

		const _this = this
		const toggle = this.querySelector('.dropdown-toggle')
		toggle.addEventListener('click', () => {
			this.classList.toggle('open')
		})

		const input = this.querySelector('.dropdown-input')
		const items = this.querySelectorAll('.dropdown-item')
		items.forEach((item) => {
			item.addEventListener('click', (event) => {
				input.textContent = item.querySelector('.input-text').textContent
				_this.classList.remove('open')
			})
		})

		document.addEventListener('click', (event) => {
			if (!this.contains(event.target)) {
				this.classList.remove('open')
			}
		})
	}
}

if (customElements.get('custom-dropdown') === undefined) {
	customElements.define('custom-dropdown', CustomDropdown)
}
